import React, { useState } from 'react';
import CurrentCustomer from './context';
import type { DataCurrentCustomerType } from './types';

type Props = {
  children: React.ReactNode;
};

export const CurrentCustomerCreationProvider = ({ children }: Props) => {
  const [coOwnerCount, setCoOwnerCount] = useState(0);
  const [currentCustomer, setCurrentCustomer] =
    useState<DataCurrentCustomerType>({
      contractId: null,
      clientId: null,
      profileId: '',
      profileDescription: '',
      profileBrief: '',
      newProfileId: '',
      fullName: '',
      onboardingComplete: false,
      onboardingCoOwnerComplete: false,
      profilingComplete: false,
      profileComplete: false,
      accountsComplete: false,
      documentsComplete: false,
      accounts: [],
    });

  const updateCoOwnerCount = () => {
    setCoOwnerCount((prevState) => prevState + 1);
  };

  const updateCurrentCustomer = (props: any) => {
    let accounts = [];
    if (props.accounts)
      accounts = props.accounts.map((item: any) => ({
        ...item,
        label: `${item.accountNumber} ${item.brokerageHouseName}`,
      }));

    setCurrentCustomer({ ...currentCustomer, ...props, accounts });
  };

  const resetCurrentCustomer = () => {
    setCurrentCustomer({
      contractId: null,
      clientId: null,
      profileId: '',
      profileDescription: '',
      profileBrief: '',
      newProfileId: '',
      fullName: '',
      onboardingComplete: false,
      profilingComplete: false,
      profileComplete: false,
      accountsComplete: false,
      documentsComplete: false,
      accounts: [],
    });
  };

  return (
    <CurrentCustomer.Provider
      value={{
        coOwnerCount,
        currentCustomer,
        updateCoOwnerCount,
        updateCurrentCustomer,
        resetCurrentCustomer,
      }}
    >
      {children}
    </CurrentCustomer.Provider>
  );
};

export default CurrentCustomerCreationProvider;
